<template>
    <div v-touch:swipe="swipeHandler">
        <div v-if="finishedCall" class="container-body">
            <div v-if="success" class="container-main">
                <div v-if="workDay">
                    <WeekOverViewLink />
                    <div style="display: flex; justify-content: space-between">
                        <div>
                            <button @click="back()" class="custom-button">
                                <i class="pi pi-chevron-left"></i>
                            </button>
                        </div>
                        <div style="margin-top: 20px">
                            {{ workDate | formatDate }}<i class="pi pi-calendar"></i>
                        </div>
                        <div>
                            <button @click="next()" class="custom-button">
                                <i class="pi pi-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                    <div class="p-field-checkbox"
                         v-if="
              workDay &&
              workDay.id !== 0 &&
              !workDay.isClosed &&
              showPassMidnight &&
              isEnabledMidnightOption()
            ">
                        <Checkbox id="passMidnight"
                                  name="passMidnight"
                                  v-model="passMidnight"
                                  @change="onPassMidnightChange"
                                  :binary="true" />
                        <label style="margin-bottom: 0px; margin-left: 5px"
                               for="passMidnight">{{ $t("NavBar.Midnight") }}</label>
                    </div>
                    <div style="display: inline">
                        <label>In:</label>
                        <label for="In">
                            <b>
                                {{
                this.cardAcess[0] != null ? this.cardAcess[0] : " --:-- "
                                }}
                            </b>
                        </label>
                        <label style="margin-left: 7px">Out:</label>
                        <label for="Out">
                            <b>
                                {{
                this.cardAcess[1] != null ? this.cardAcess[1] : " --:-- "
                                }}
                            </b>
                        </label>
                    </div>
                    <div v-if="!showAddMenu">
                        <div v-if="workDay.id !== 0" id="workslip">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">{{ $t("Workday.Start") }}</th>
                                        <th scope="col">{{ $t("Workday.End") }}</th>
                                        <th scope="col"></th>
                                        <th scope="col">{{ $t("Workday.Summary") }}</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tr v-for="(item, index) in workRegistrations"
                                    :key="item.id"
                                    @click="select(item)"
                                    v-bind:class="{
                    selected: item.selected,
                  }">
                                    <td>{{ index + 1 }}</td>
                                    <td v-if="!workDay.isClosed">
                                        <datetime disabled
                                                  v-bind:type="passMidnight ? 'datetime' : 'time'"
                                                  v-model="item.startTime"
                                                  v-bind:format="passMidnight ? 'dd/HH:mm' : 'HH:mm'"
                                                  input-style="text-align:center"
                                                  class="theme-blue"
                                                  v-bind:class="{ error: item.invalidStartTime }"
                                                  v-bind:backdrop-click="false"
                                                  :min-datetime="passMidnight ? minDatetime : null"
                                                  :max-datetime="passMidnight ? maxDatetime : null">
                                            <template slot="button-cancel">
                                                <div>Cancel</div>
                                            </template>
                                            <template slot="button-confirm">
                                                <div @click="onChangeStartTime(index)">Confirm</div>
                                            </template>
                                        </datetime>
                                    </td>
                                    <td v-else>{{ item.startTime | formatDateHourlyWithDay }}</td>
                                    <td v-if="!workDay.isClosed">
                                        <datetime disabled
                                                  v-bind:type="passMidnight ? 'datetime' : 'time'"
                                                  v-bind:format="passMidnight ? 'dd/HH:mm' : 'HH:mm'"
                                                  v-model="item.endTime"
                                                  input-style="text-align:center"
                                                  class="theme-blue"
                                                  v-bind:class="{ error: item.invalidEndTime }"
                                                  v-bind:backdrop-click="false"
                                                  :min-datetime="passMidnight ? minDatetime : null"
                                                  :max-datetime="passMidnight ? maxDatetime : null">
                                            <template slot="button-cancel">
                                                <div>Cancel</div>
                                            </template>
                                            <template slot="button-confirm">
                                                <div @click="onChangeEndTime(index)">Confirm</div>
                                            </template>
                                        </datetime>
                                    </td>
                                    <td v-else>{{ item.endTime | formatDateHourlyWithDay }}</td>
                                    <td v-if="item.description">
                                        <i class="pi pi-exclamation-triangle"
                                           style="font-size: 1.7rem"
                                           v-if="
                        item.description.includes('Damage') ||
                        item.description.includes('NotAgreed')
                      "></i>
                                    </td>
                                    <td v-else></td>
                                    <td v-tooltip="projectNameTooltip(item.summary)">
                                        {{ formatSummary(item.summary) }}
                                    </td>
                                    <td style="display: flex;align-items: center; justify-content: center;">
                                        <div class="tooltip-wrapper">
                                            <div class="tooltip-button"
                                                 v-if="item.description && /\S/.test(item.description)"
                                                 @click.stop="toggleTooltip(item.id)">
                                                <i class="pi pi-info-circle" style="font-size: 1.4rem"></i>
                                                <div class="tooltip-text" v-if="showTooltip === item.id">{{ item.description }}</div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <button v-if="travelWithoutEndTime && isCurrentDay"
                                class="custom-mobile-button"
                                @click="endActivity()">
                            {{ travelTimeButtonLabel }}
                        </button>
                        <button v-if="pauseWithoutEndTime && isCurrentDay"
                                class="custom-mobile-button"
                                @click="endActivity()">
                            {{ pauseButtonLabel }}
                        </button>
                        <button v-if="projectWithoutEndTime && isCurrentDay"
                                class="custom-mobile-button"
                                @click="endActivity()">
                            {{ projectButtonLabel }}
                        </button>
                        <button v-if="otherWithoutEndTime && isCurrentDay"
                                class="custom-mobile-button"
                                @click="endActivity()">
                            {{ otherButtonLabel }}
                        </button>
                        <button v-if="!workDay.isClosed"
                                class="custom-mobile-button"
                                @click="createWorkRegistration">
                            {{ $t("Workday.Add") }}
                        </button>

                        <button v-if="!workDay.isClosed"
                                :disabled="!selectedWorkRegistration"
                                class="custom-mobile-button"
                                @click="editWorkRegistration">
                            {{ $t("Workday.Edit") }}
                        </button>
                        <button v-if="!workDay.isClosed"
                                :disabled="!selectedWorkRegistration"
                                class="custom-mobile-button"
                                @click="showConfirmationModalForDelete = true">
                            {{ $t("Workday.Delete") }}
                        </button>
                        <!--When UTA isValidatedStaffing not applicable--> 
                        <div v-if="!workDay.isProcessed && !workDay.isValidated && ((this.isCAOEmployee && !workDay.isValidatedStaffing) || !this.isCAOEmployee)">
                            <button class="custom-mobile-button"
                                    @click="showConfirmationModalForDeleteWorkDay = true">
                                {{ $t("Workday.DeleteWorkDay") }}
                            </button>
                            <button class="custom-mobile-button" 
                                    v-if="workDay.isClosed"
                                      @click="showConfirmationModalForOpen = true">
                                  {{ $t("Workday.OpenDay") }}
                              </button>
                        </div>
                        <div v-else style="margin-top: 10px">
                            <span class="text-warning">
                                {{ $t("Workday.DayClosedByManager") }}
                            </span>
                        </div>
                        <button class="custom-mobile-button"
                                v-if="!workDay.isClosed"
                                @click="checkForOvertime"
                                :disabled="isCloseDayDisabled">
                            {{ $t("Workday.CloseDay") }}
                        </button>
                    </div>
                    <div v-else>
                        <button class="custom-mobile-button" @click="addTravelTime()">
                            {{ travelTimeButtonLabel }}
                        </button>
                        <button class="custom-mobile-button" @click="addPause()">
                            {{ pauseButtonLabel }}
                        </button>
                        <button class="custom-mobile-button" @click="addProjectActivity()">
                            {{ projectButtonLabel }}
                        </button>
                        <button class="custom-mobile-button" @click="otherSelection()">
                            {{ otherButtonLabel }}
                        </button>
                        <button v-if="workDay.workRegistrations && workDay.workRegistrations.length >= 1"
                                class="custom-mobile-button"
                                @click="showAddMenu = false">
                            {{ $t("Confirmation.Cancel") }}
                        </button>
                    </div>

                    <!--           <div v-else>
                      <button
                        class="custom-mobile-button"
                        @click="createWorkRegistration"
                      >
                        {{ $t("Workday.Add") }}
                      </button>
                      <button class="custom-mobile-button" @click="onConfirmSelectedDay">
                        {{ $t("Workdays.AddStandardDay") }}
                      </button>
                    </div> -->
                    <!--<div v-else style="margin-top: 20px">
                      {{ $t("Workday.NoWorkday") }}
                    </div>-->
                    <!--            <button  v-if="!isCAOEmployee" class="custom-mobile-button" @click="testWR()">
                                  {{ $t("Workdays.AddStandardDay") }}
                                </button> -->
                    <!--NB: isAddStandardDayButtonDisabled instead of this.workDay.workRegistrations.length not working-->
                    <button v-if="!isCAOEmployee && !workDay.workRegistrations.length > 0 && contractFormat.standardDay"
                            class="custom-mobile-button"
                            @click="addDefaultDay">
                        {{ $t("Workdays.AddStandardDay") }}
                    </button>
                </div>

                <Confirmation @confirmed="onConfirmedDelete"
                              :question="confirmationQuestion"
                              :display="showConfirmationModalForDelete" />
                <Confirmation @confirmed="onConfirmedOpen"
                              :question="confirmationOpenDay"
                              :display="showConfirmationModalForOpen" />
                <Confirmation @confirmed="onConfirmedDeleteWorkDay"
                              :question="confirmationDeleteWorkDay"
                              :display="showConfirmationModalForDeleteWorkDay" />
                <Confirmation @confirmed="onConfirmCloseDay"
                              :question="confirmationCloseWorkDay"
                              :display="showConfirmationModalForCloseWorkDay" />
                <Confirmation @confirmed="onConfirmDeclareMidnight"
                              :question="confirmationDeclareMidnight"
                              :display="showConfirmationModalForMidnight" />
                <Confirmation @confirmed="onConfirmTravelTime"
                              :question="confirmationTravelTime"
                              :display="showConfirmationModalForTravelTime" />
                <Confirmation @confirmed="onConfirmUnregisteredWorkslips"
                              :question="confirmationUnregisteredWorkslips"
                              :display="showConfirmationModalForUnregisteredWorkslips" />
                <!-- <DriverSelector
                  v-if="selectedWorkRegistration"
                  :display="showDriverModal"
                  :drivers="workDay.drivers"
                  :selectedWorkRegistration="selectedWorkRegistration"
                  @confirmed="onSelectedDriver"
                /> -->
                <WorkRegistrationEndTimeDialog :display="showEndTimeDialog"
                                               @confirmed="onSelectedEndTime" />
                <Confirmation v-if="this.isWorkSlipEmployee"
                              @confirmed="onConfirmBreak"
                              :question="$t('WorkRegistrationForm.BreakMessage')"
                              :checkBoxMessage="$t('WorkRegistrationForm.BreakCheckbox')"
                              :display="showBreakModal"
                              :showNoButton="true" />
                <Confirmation v-else
                              @confirmed="onConfirmBreak"
                              :question="$t('WorkRegistrationForm.BreakMessage')"
                              :display="showBreakModal"
                              :showNoButton="true" />
                <Confirmation @confirmed="onConfirmOvernight"
                              :question="$t('Workday.OvernightQuestion')"
                              :display="showOvernightModal"
                              :showNoButton="true" />
                <Confirmation @confirmed="onConfirmOvertime"
                              :question="$t('Workday.OvertimeQuestion')"
                              :display="showOvertimeModal"
                              :showNoButton="true" />
                <Confirmation @confirmed="onConfirmDamage"
                              :question="damageQuestion"
                              :display="showDamageModal"
                              :showNoButton="true" />
            </div>
        </div>
    </div>
</template>

<script>
    import WorkDayService from "../services/WorkDayService";
    import Confirmation from "../components/common/Confirmation";
    import WorkRegistrationService from "../services/WorkRegistrationService";
    import moment from "moment";
    import { formatDateServer, formatDateTimeServer } from "../utils";
    import WorkSlipService from "../services/WorkSlipService";
    import WeekOverViewLink from "../components/common/WeekOverViewLink";
    import LocalStorageService from "../services/LocalStorageService";
    import WorkRegistrationEndTimeDialog from "../components/common/WorkRegistrationEndTimeDialog";
    import ActivityService from "../services/ActivityService";

    export default {
        name: "WorkDay",
        workDayService: null,
        workRegistrationService: null,
        workSlipService: null,
        activityService: null,
        data() {
            return {
                showTooltip: null,
                loader: {},
                success: true,
                finishedCall: false,
                workDay: null,
                selectedWorkRegistration: null,
                confirmationQuestion: this.$t("Workday.ConfirmationQuestion"),
                confirmationOpenDay: this.$t("Workday.ConfirmationOpenDay"),
                confirmationDeleteWorkDay: this.$t("Workday.ConfirmationDeleteWorkDay"),
                confirmationCloseWorkDay: this.$t("WorkSlip.ConfirmationCloseDay"),
                confirmationCloseDay: this.$t("WorkSlip.ConfirmationCloseDay"),
                confirmationTravelTime: this.$t("WorkSlip.ConfirmationTravelTime"),
                confirmationTravelTimePlural: this.$t("WorkSlip.ConfirmationTravelTimePlural"),
                confirmationUnregisteredWorkslips: this.$t(
                    "WorkSlip.UnregisteredWorkslips"
                ),
                confirmationDeclareMidnight: this.$t(
                    "WorkSlip.ConfirmationDeclareMidnight"
                ),
                showConfirmationModalForDelete: false,
                showConfirmationModalForTravelTime: false,
                showCloseDayModal: false,
                showConfirmationModalForOpen: false,
                showConfirmationModalForDeleteWorkDay: false,
                showConfirmationModalForCloseWorkDay: false,
                showConfirmationModalForMidnight: false,
                showConfirmationModalForStandardDay: false,
                showDriverModal: false,
                workDate: null,
                workRegistrations: null,
                showConfirmationModalForClose: false,
                isWorkSlipEmployee: false,
                localStorageService: null,
                passMidnight: false,
                maxDatetime: null,
                minDatetime: null,
                showPassMidnight: false,
                employee: null,
                selectedEndDate: null,
                selectedStartDate: null,
                selectedIndex: null,
                selectedLastEndDate: null,
                workSlips: null,
                workSlipsArray: [],
                drivers: [],
                cardAcess: [],
                gildeWorkslipsWithTravelTime: [],
                showEndTimeDialog: false,
                isAddStandardDayButtonDisabled: false,
                addedEndTime: false,
                showConfirmationModalForUnregisteredWorkslips: false,
                unregisteredWorkslips: null,
                showAddMenu: false,
                activities: null,
                travelTimeButtonLabel: this.$t("Workday.AddTravelTime"),
                pauseButtonLabel: this.$t("Workday.EnterPause"),
                projectButtonLabel: this.$t("Workday.ProjectActivity"),
                otherButtonLabel: this.$t("Workday.Other"),
                showBreakModal: false,
                isCAOEmployee: false,
                isCloseDayDisabled: false,
                travelWithoutEndTime: false,
                pauseWithoutEndTime: false,
                otherWithoutEndTime: false,
                projectWithoutEndTime: false,
                isCurrentDay: false,
                isEmployeeStayingOvernight: false,
                showOvernightModal: false,
                contractFormat: null,
                showOvertimeModal: false,
                overtimeInHours: null,
                showDamagePage: false,
                showDamageModal: false,
                damageQuestion: this.$t("WorkRegistrationForm.DamageQuestion"),
                saveDay: false,
                damageDescription: "",
                editDamage: false,
                distance: "",
                licensePlate: "",
                isDriver: false,
                selectedCarType: null,
                contractStandardDay: false,
                declare: false,
                pauseDActivityCodes: ["110.103.02.003", "110.109.02.003", "110.126.02.003", "110.127.02.003", "110.161.02.003","110.165.02.003", "110.166.02.003", "110.179.02.003", "110.182.02.003", "110.160.02.003", "110.147.02.004", "113.000.00.001"]
            };
        },
        components: {
            Confirmation,
            WeekOverViewLink,
            WorkRegistrationEndTimeDialog,
        },

        created() {
            console.log(window.location.hash);

            var selectedDay = localStorage.getItem("selectedWorkDay");
            console.log('selectedWorkDay: ' + selectedDay);

            if (window.location.hash.startsWith('#/work-day?') && selectedDay == null) {
                window.location.hash = '#/work-day?workDate=' + this.getCurrentDate();
            }

            this.workDayService = new WorkDayService();
            this.workRegistrationService = new WorkRegistrationService();
            this.workSlipService = new WorkSlipService();
            this.workDate = this.$route.query.workDate;
            this.localStorageService = new LocalStorageService();
            this.employee = this.localStorageService.getCurrentEmployee();
            this.isWorkSlipEmployee = this.employee.isWorkSlipEmployee;
            this.isCAOEmployee = this.employee.isCAOEmployee;
            this.activityService = new ActivityService();
            this.overnightCheck();
            this.getContractFormat();
            if (
                new Date(new Date(this.workDate).setHours(0, 0, 0, 0)).getTime() >
                new Date().getTime()
            ) {
                this.isCloseDayDisabled = true;
            }
        },
        mounted() {
            this.getWorkDay();
            this.getAssignedWorkSlips();

        },
        methods: {
            toggleTooltip(itemId) {
                if (this.showTooltip === itemId) {
                    this.showTooltip = null;
                } else {
                    this.showTooltip = itemId;
                }
            },
            getCurrentDate() {
                let currentDate = new Date().setHours(0, 0, 0, 0);
                currentDate = moment(currentDate).toISOString();
                return currentDate;
            },
            addDefaultDay() {
                let workDates = [];
                workDates.push(formatDateServer(this.workDate));
                this.createWorkDays(workDates, 1);
            },
            onConfirmSelectedDay() {
                if (this.workDay.id == 0) {
                    this.workDayService.createWorkDay(this.workDate).then((response) => {
                        this.workDayId = response.data.id;
                        let workDates = [];
                        workDates.push(this.workDate);
                        this.createWorkDays(workDates, 1);
                    });
                } else {
                    let workDates = [];
                    workDates.push(formatDateTimeServer(this.workDate));
                    this.createWorkDays(workDates, 1);
                }
            },
            createWorkDays(workDates, dayType) {
                this.loader = this.$loading.show({});
                let clockedHours = this.cardAcess.length > 0 ? true : false;
                this.workDayService
                    .createWorkDays(workDates, dayType, clockedHours)
                    .then((res) => {
                        this.workDays = res.data;
                        this.loader.hide();
                        //this.getWorkDay();
                        this.$router.push({
                            name: "work-days",
                            query: {
                                //ts: new Date().getTime(),
                                workDate: this.workDate,
                            },
                        });
                    })
                    .catch(() => {
                        this.loader.hide();
                    });
            },
            areEqual(array1, array2) {
                if (array1.length === array2.length) {
                    return array1.every((element, index) => {
                        if (element === array2[index]) {
                            return true;
                        }
                        return false;
                    });
                }
                return false;
            },
            onSelectedEndTime(event) {
                this.showEndTimeDialog = false;
                this.workRegistrations[this.workRegistrations.length - 1].endTime =
                    event.value;
                this.updateWorkRegistrationEndTime();
            },
            onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            },
            getAssignedWorkSlips() {
                this.workSlipService
                    .getWorkSlipOptions(this.workDate)
                    .then((response) => {
                        const result = response.data;
                        if (result) {
                            this.workSlips = result;
                            this.workSlipsArray = this.workSlips.map(({ value }) => value);
                        }
                    })
                    .catch(() => { });
            },
            checkAssignedWorkSlipsVsWorkRegistrations() {
                let registeredWorkSlips = this.workRegistrations.map(
                    ({ workSlipNumber }) => workSlipNumber
                );
                let uniqueRegisteredWorkSlips = registeredWorkSlips.filter(
                    this.onlyUnique
                );
                var filteredregisteredWorkSlips = uniqueRegisteredWorkSlips.filter(
                    function (el) {
                        return el != null;
                    }
                );
                let unassignedWorkslips = this.workSlipsArray.filter(function (val) {
                    return filteredregisteredWorkSlips.indexOf(val) == -1;
                });
                return unassignedWorkslips;
                /*if (this.workSlipsArray.length > 0) {
                  if (this.areEqual(filteredregisteredWorkSlips, this.workSlipsArray)) {
                    return true;
                  }
                  return false;
                } else {
                  return true;
                }*/
            },
            projectNameTooltip(summary) {
                var words = summary.split(" /");
                return String(words[0]);
            },
            formatSummary(summary) {
                var words = summary.split(" /");
                this.projectName = words[0];
                if (this.projectName.length > 10) {
                    var trimmedString = words[0].substring(0, 10);
                    trimmedString += "...";
                    return trimmedString + "/" + words[1];
                } else {
                    return summary;
                }
            },
            onConfirmDeclareMidnight(value) {
                this.showConfirmationModalForMidnight = false;
                if (value && value === true) {
                    this.showPassMidnight = true;
                    this.passMidnight = true;
                    if (this.selectedEndDate) {
                        this.selectedWorkRegistration.endTime = moment(this.selectedEndDate)
                            .add(1, "days")
                            .format("YYYY-MM-DD[T]HH:mm:00");
                        this.onChangeEndTime(this.selectedIndex);
                    }
                    if (this.selectedStartDate) {
                        this.selectedWorkRegistration.startTime = moment(
                            this.selectedStartDate
                        )
                            .add(1, "days")
                            .format("YYYY-MM-DD[T]HH:mm:00");
                        this.onChangeStartTime(this.selectedIndex);
                    }
                }
            },
            onChangeEndTime(index) {
                setTimeout(() => {
                    let selectedWorkRegistration = this.workRegistrations[index];
                    if (selectedWorkRegistration && selectedWorkRegistration.startTime) {
                        if (index === this.workRegistrations.length - 1) {
                            if (!this.selectedLastEndDate) {
                                //first selected end date
                                const now = moment(new Date()).day();
                                const endDay = moment(selectedWorkRegistration.endTime).day();
                                const startDay = moment(selectedWorkRegistration.startTime).day();
                                const startMonth = moment(
                                    selectedWorkRegistration.startTime
                                ).month();
                                const endMonth = moment(selectedWorkRegistration.endTime).month();
                                const startYear = moment(
                                    selectedWorkRegistration.startTime
                                ).year();
                                const endYear = moment(selectedWorkRegistration.endTime).year();
                                if (
                                    !this.passMidnight &&
                                    endDay === now &&
                                    (startDay !== endDay ||
                                        startMonth === endMonth ||
                                        startYear === endYear)
                                ) {
                                    let _end = moment(selectedWorkRegistration.endTime);
                                    let _m = _end.minutes();
                                    let _h = _end.hours();
                                    selectedWorkRegistration.endTime = moment(
                                        selectedWorkRegistration.startTime
                                    )
                                        .hours(_h)
                                        .minutes(_m)
                                        .format("YYYY-MM-DD[T]HH:mm:00");
                                }
                                this.selectedLastEndDate = Object.assign(
                                    {},
                                    selectedWorkRegistration.endTime
                                );
                            }
                        }
                        let start = moment(selectedWorkRegistration.startTime);
                        let end = moment(selectedWorkRegistration.endTime);

                        this.selectedStartDate = null;
                        this.selectedEndDate = end;
                        this.selectedIndex = index;
                        const firstWrStartTime = moment(this.workRegistrations[0].startTime);
                        let diffForFirstWr = end.diff(firstWrStartTime, "hours");
                        //check 00:00
                        if (
                            !this.passMidnight &&
                            diffForFirstWr < 0 &&
                            end.hours() < 10 &&
                            this.isEnabledMidnightOption()
                        ) {
                            this.showConfirmationModalForMidnight = true;
                            return;
                        }
                        //check if it is different date
                        let diffDays = Math.abs(start.diff(end, "days"));
                        if (!this.passMidnight && diffDays === 1) {
                            let minutes = end.minutes();
                            let hours = end.hours();
                            selectedWorkRegistration.endTime = moment(start)
                                .hours(hours)
                                .minutes(minutes)
                                .format("YYYY-MM-DD[T]HH:mm:00");
                            end = moment(selectedWorkRegistration.endTime);
                        }
                        if (start.isAfter(end) || start.isSame(end)) {
                            selectedWorkRegistration.startTime = end
                                .add(-1, "minutes")
                                .format("YYYY-MM-DD[T]HH:mm:00");
                        }
                        this.fixBefore(index);
                        this.fixAfter(index);
                        this.updateWorkRegistrationDates();
                    }
                }, 500);
            },
            onChangeStartTime(index) {
                setTimeout(() => {
                    let selectedWorkRegistration = this.workRegistrations[index];
                    if (selectedWorkRegistration && selectedWorkRegistration.startTime) {
                        let start = moment(selectedWorkRegistration.startTime);
                        let end = moment(selectedWorkRegistration.endTime);
                        this.selectedStartDate = start;
                        this.selectedEndDate = null;
                        this.selectedIndex = index;
                        const firstWrStartTime = moment(this.workRegistrations[0].startTime);
                        let diffForFirstWr = start.diff(firstWrStartTime, "hours");
                        //check 00:00
                        if (
                            !this.passMidnight &&
                            diffForFirstWr < 0 &&
                            start.hours() < 10 &&
                            this.isEnabledMidnightOption()
                        ) {
                            this.showConfirmationModalForMidnight = true;
                            return;
                        }
                        if (start.isAfter(end) || start.isSame(end)) {
                            selectedWorkRegistration.endTime = start
                                .add(1, "minutes")
                                .format("YYYY-MM-DD[T]HH:mm:00");
                        }
                        this.fixBefore(index);
                        this.fixAfter(index);
                        this.updateWorkRegistrationDates();
                    }
                }, 500);
            },
            fixBefore(index) {
                for (let i = index; i >= 0; i--) {
                    let selectedWorkRegistration = this.workRegistrations[i];
                    if (selectedWorkRegistration) {
                        let prev = this.workRegistrations[i - 1];
                        if (prev) {
                            if (prev.endTime !== selectedWorkRegistration.startTime) {
                                prev.endTime = selectedWorkRegistration.startTime;
                            }
                            let start = moment(prev.startTime);
                            let end = moment(prev.endTime);
                            if (start.isAfter(end) || start.isSame(end)) {
                                prev.startTime = end
                                    .add(-1, "minutes")
                                    .format("YYYY-MM-DD[T]HH:mm:00");
                            }
                        }
                    }
                }
            },
            fixAfter(index) {
                for (let i = index; i < this.workRegistrations.length; i++) {
                    let selectedWorkRegistration = this.workRegistrations[i];
                    if (selectedWorkRegistration) {
                        let next = this.workRegistrations[i + 1];
                        if (next) {
                            if (next.startTime !== selectedWorkRegistration.endTime) {
                                next.startTime = selectedWorkRegistration.endTime;
                            }
                            let start = moment(next.startTime);
                            let end = moment(next.endTime);
                            if (start.isAfter(end) || start.isSame(end)) {
                                next.endTime = start
                                    .add(1, "minutes")
                                    .format("YYYY-MM-DD[T]HH:mm:00");
                            }
                        }
                    }
                }
            },
            wdAutoCreate() {
                this.loader = this.$loading.show({});
                const workDate = formatDateServer(this.workDate);
                if (this.isWorkSlipEmployee) {
                    this.workSlipService
                        .getWorkSlip(workDate)
                        .then((res) => {
                            this.onSuccessLoadWorkDay(res);
                        })
                        .catch(() => {
                            this.finishedCall = true;
                            this.success = false;
                            this.loader.hide();
                        });
                }
            },
            getWorkDay() {
                this.loader = this.$loading.show({});
                const workDate = formatDateServer(this.workDate);
                this.workDayService
                    .getWorkDay(workDate)
                    .then((res) => {
                        this.travelWithoutEndTime = false;
                        this.pauseWithoutEndTime = false;
                        this.projectWithoutEndTime = false;
                        this.otherWithoutEndTime = false;
                        this.onSuccessLoadWorkDay(res);
                        this.getActivities();
                        if (new Date(this.workDate).getDate() == new Date().getDate()) {
                            this.isCurrentDay = true;
                        } else {
                            this.isCurrentDay = false;
                        }
                    })
                    .catch(() => {
                        this.finishedCall = true;
                        this.success = false;
                        this.loader.hide();
                    });
            },
            checkTravelTime() {
                var existingTravelTasks = 0;
                if (
                    this.workDay.travelTimeTasks != null &&
                    this.workDay.travelTimeTasks == true
                ) {
                    this.workRegistrations.forEach((wr) => {
                        if (wr.activityTypeId == 182) existingTravelTasks++;
                    });
                    if (
                        existingTravelTasks == 1 &&
                        this.workDay.gildeWorkslipsWithTravelTime.length == 1
                    ) {
                        //warning case
                        this.showConfirmationModalForTravelTime = true;
                    } else if (
                        existingTravelTasks > 1 &&
                        this.workDay.gildeWorkslipsWithTravelTime.length > 1
                    ) {
                        if (
                            this.workDay.gildeWorkslipsWithTravelTime.length >
                            existingTravelTasks
                        ) {
                            let missingTrips =
                                this.workDay.gildeWorkslipsWithTravelTime.length -
                                existingTravelTasks;
                            let message = `${this.$t(
                                "WorkSlip.ConfirmationTravelTimeMultiplePrefix"
                            )}${missingTrips}${this.$t(
                                "WorkSlip.ConfirmationTravelTimeMultipleSuffix"
                            )}`;
                            this.$toast.add({
                                severity: "warn",
                                detail: message,
                                life: 3000,
                                closable: false,
                            });
                        } else if (
                            this.workDay.gildeWorkslipsWithTravelTime.length ==
                            existingTravelTasks
                        ) {
                            this.showConfirmationModalForTravelTime = true;
                            if (existingTravelTasks == 1) {
                                this.confirmationTravelTime = this.confirmationTravelTime.replace(
                                    "1",
                                    existingTravelTasks.toString()
                                );
                            }
                            else {
                                this.confirmationTravelTime = this.confirmationTravelTimePlural.replace(
                                    "X",
                                    existingTravelTasks.toString()
                                );
                            }
                        } else if (
                            this.workDay.gildeWorkslipsWithTravelTime.length <
                            existingTravelTasks &&
                            existingTravelTasks %
                            this.workDay.gildeWorkslipsWithTravelTime.length !=
                            0
                        ) {
                            this.showConfirmationModalForTravelTime = true;
                            if (existingTravelTasks == 1) {
                                this.confirmationTravelTime = this.confirmationTravelTime.replace(
                                    "1",
                                    existingTravelTasks.toString()
                                );
                            }
                            else {
                                this.confirmationTravelTime = this.confirmationTravelTimePlural.replace(
                                    "X",
                                    existingTravelTasks.toString()
                                );
                            }
                        } else {
                            this.closeDay();
                        }
                    } else if (
                        existingTravelTasks == 1 &&
                        this.workDay.gildeWorkslipsWithTravelTime.length > 1
                    ) {
                        let missingTrips =
                            this.workDay.gildeWorkslipsWithTravelTime.length -
                            existingTravelTasks;
                        let message = `${this.$t(
                            "WorkSlip.ConfirmationTravelTimeMultiplePrefix"
                        )}${missingTrips}${this.$t(
                            "WorkSlip.ConfirmationTravelTimeMultipleSuffix"
                        )}`;
                        this.$toast.add({
                            severity: "warn",
                            detail: message,
                            life: 3000,
                            closable: false,
                        });
                    } else if (existingTravelTasks == 0) {
                        //error
                        this.workDayService.closeWorkdayError();
                    } else {
                        this.closeDay();
                    }
                } else {
                    this.closeDay();
                }
            },
            onConfirmTravelTime(value) {
                this.showConfirmationModalForTravelTime = false;
                if (value && value === true) {
                    this.closeDay();
                }
            },
            onSuccessLoadWorkDay(res) {
                this.workDay = res.data;
                this.minDatetime = this.workDay.workDate;
                this.maxDatetime = moment(this.workDay.workDate)
                    .add(1, "days")
                    .add(23, "hours")
                    .add(59, "minutes")
                    .format("YYYY-MM-DD[T]HH:mm:00");
                this.employee = this.localStorageService.getCurrentEmployee();
                this.passMidnight =
                    this.localStorageService.getCurrentEmployee().isEnabledMidnightOption ||
                    false;
                this.showPassMidnight =
                    this.localStorageService.getCurrentEmployee().isEnabledMidnightOption ||
                    false;
                if (this.workDay.gildeWorkslipsWithTravelTime.length > 0) {
                    this.gildeWorkslipsWithTravelTime =
                        this.workDay.gildeWorkslipsWithTravelTime;
                }
                if (this.workDay.workRegistrations.length > 0) {
                    this.workRegistrations = this.workDay.workRegistrations;
                    this.isAddStandardDayButtonDisabled = true;
                    const isMidnight = this.workRegistrations.some(
                        (w) =>
                            w.endTime && moment(w.startTime).day() !== moment(w.endTime).day()
                    );
                    if (isMidnight === true) {
                        this.passMidnight = true;
                        this.showPassMidnight = true;
                    }
                } else {
                    this.showAddMenu = true;
                }
                this.selectedEndDate = null;
                this.selectedLastEndDate = null;
                this.finishedCall = true;
                this.success = true;
                this.loader.hide();
                this.getCardAccess(this.workDay);
            },
            deleteWorkDay() {
                this.loader = this.$loading.show({});
                this.workDayService
                    .deleteWorkDay(this.workDay.id)
                    .then(() => {
                        this.loader.hide();
                        return this.$router.push({
                            name: "work-days",
                            query: {
                                //ts: new Date().getTime(),
                                workDate: this.workDate,
                            },
                        });
                    })
                    .catch(() => {
                        this.loader.hide();
                    });
            },
            deleteWorkRegistration() {
                this.loader = this.$loading.show({});
                this.workRegistrationService
                    .deleteWorkRegistration(this.selectedWorkRegistration.id)
                    .then(() => {
                        this.loader.hide();
                        this.getWorkDay();
                    })
                    .catch(() => {
                        this.loader.hide();
                        this.finishedCall = true;
                        this.success = false;
                    });
            },
            closeDay() {
                this.loader = this.$loading.show({});
                this.unregisteredWorkslips =
                    this.checkAssignedWorkSlipsVsWorkRegistrations();
                let closeWorkDayModel = {
                    workDayId: this.workDay.id,
                    workRegistrations: this.workRegistrations.map((w) => {
                        return {
                            id: w.id,
                            startTime: formatDateTimeServer(w.startTime),
                            endTime: formatDateTimeServer(w.endTime),
                        };
                    }),
                    overtime: this.overtimeInHours,
                    declare: this.declare
                };
                if (this.unregisteredWorkslips.length == 0) {
                    this.splitTravelTime().then(() => {
                        this.workDayService
                            .closeWorkDay(closeWorkDayModel)
                            .then(() => {
                                this.loader.hide();
                                this.getWorkDay();
                            })
                            .catch(() => {
                                this.loader.hide();
                            });
                    });
                } else {
                    if (this.isWorkSlipEmployee == 1) {
                        this.loader.hide();
                        this.showConfirmationModalForUnregisteredWorkslips = true;
                    } else {
                        this.workDayService
                            .closeWorkDay(closeWorkDayModel)
                            .then(() => {
                                this.loader.hide();
                                this.getWorkDay();
                            })
                            .catch(() => {
                                this.loader.hide();
                            });
                    }
                }
                //this.loader.hide();
            },
            onConfirmUnregisteredWorkslips(value) {
                this.loader = this.$loading.show({});
                this.showConfirmationModalForUnregisteredWorkslips = false;
                if (value && value === true) {
                    let closeWorkDayModel = {
                        workDayId: this.workDay.id,
                        workRegistrations: this.workRegistrations.map((w) => {
                            return {
                                id: w.id,
                                startTime: formatDateTimeServer(w.startTime),
                                endTime: formatDateTimeServer(w.endTime),
                            };
                        }),
                        unregisteredWorkslips: this.unregisteredWorkslips,
                        employeeName: this.employee.name,
                        overtime: this.overtimeInHours,
                    };
                    this.splitTravelTime().then(() => {
                        this.workDayService
                            .closeWorkDay(closeWorkDayModel)
                            .then(() => {
                                this.loader.hide();
                                this.getWorkDay();
                            })
                            .catch(() => {
                                this.loader.hide();
                            });
                    });
                } else {
                    this.loader.hide();
                }
            },
            openDay() {
                this.loader = this.$loading.show({});
                this.workDayService
                    .openWorkDay(this.workDay.id)
                    .then(() => {
                        this.loader.hide();
                        this.getWorkDay();
                    })
                    .catch(() => {
                        this.loader.hide();
                        this.finishedCall = true;
                        this.success = false;
                    });
            },
            onConfirmedDeleteWorkDay(value) {
                this.showConfirmationModalForDeleteWorkDay = false;
                if (value && value === true) {
                    this.deleteWorkDay();
                }
            },
            onConfirmedDelete(value) {
                this.showConfirmationModalForDelete = false;
                if (value && value === true) {
                    if (this.workRegistrations.length == 1) {
                        this.deleteWorkDay();
                    } else {
                        this.deleteWorkRegistration();
                    }
                }
            },
            onConfirmCloseDay(value) {
                this.showConfirmationModalForCloseWorkDay = false;
                if (value && value === true) {
                    this.checkTravelTime();
                }
            },
            async splitTravelTime() {
                const existingTravelTasks = [];
                this.workRegistrations.forEach((wr) => {
                    if (wr.activityTypeId == 182) existingTravelTasks.push(wr); //get all travel WRs
                });
                for (const wr of existingTravelTasks) {
                    {
                        let workSlipsWithSameProjectId = [];
                        var currentWorkSlip = this.workSlips.find((ws) => {
                            if (wr.workSlipNumber === ws.workSlipNumber) return ws; //get current workslip
                        });
                        if (!currentWorkSlip) {
                            return;
                        }
                        this.workSlips.find((ws) => {
                            if (
                                ws.projectId === currentWorkSlip.projectId &&
                                ws.workSlipNumber !== wr.workSlipNumber
                            )
                                workSlipsWithSameProjectId.push(ws.workSlipNumber); //get all workslips with currentWorkslip projectId
                        });
                        let maxTravelTasks = workSlipsWithSameProjectId.length + 1;
                        workSlipsWithSameProjectId.forEach((ws) => {
                            //check the number of registered travel tasks for each workslip with common projectId
                            let noOfRegisteredTravelTasks = 0;
                            existingTravelTasks.forEach((travelWr) => {
                                if (travelWr.workSlipNumber === ws) noOfRegisteredTravelTasks++;
                            });
                            if (noOfRegisteredTravelTasks >= maxTravelTasks)
                                workSlipsWithSameProjectId = workSlipsWithSameProjectId.filter(
                                    function (obj) {
                                        return obj != ws;
                                    }
                                );
                        });

                        if (workSlipsWithSameProjectId.length >= 1) {
                            let splitTravelTimeModel = {
                                workRegistrationId: wr.id,
                                workSlips: workSlipsWithSameProjectId,
                            };
                            workSlipsWithSameProjectId.forEach((ws) => {
                                existingTravelTasks.push({ workSlipNumber: ws });
                            });
                            await this.workDayService.splitWorkdayTravelTasks(
                                splitTravelTimeModel
                            );
                        }
                    }
                }
            },
            onConfirmedOpen(value) {
                this.showConfirmationModalForOpen = false;
                if (value && value === true) {
                    this.workDay.isClosed = false;
                    this.openDay();
                }
            },
            onSelectedDriver(value) {
                this.showDriverModal = false;
                if (value && value.value === true) {
                    this.selectedWorkRegistration.driver = value.driver;
                }
            },
            editWorkRegistration() {
                localStorage.setItem("selectedWorkDay", this.workDate)

                this.workRegistrationService
                    .getWorkRegistration(this.selectedWorkRegistration.id)
                    .then((response) => {
                        var currentActivity = this.getActivityById(
                            response.data.activityId.toString()
                        );
                        if (currentActivity.activityCode == "120.000.00.001") {
                            return this.$router.push({
                                name: "add-travel-time",
                                query: {
                                    workday: this.workDay,
                                    workRegistrationId: this.selectedWorkRegistration.id,
                                    workDate: formatDateServer(this.workDate),
                                    isMidnight: this.passMidnight,
                                    workDayId: this.workDay.id,
                                    workDayEndTime: this.workDay.endTime,
                                    workRegistration: response.data,
                                    drivers: this.workDay.drivers,
                                    addTimeManually: this.selectedWorkRegistration.endTime
                                        ? true
                                        : false,
                                    showDamagePage: this.showDamagePage,
                                    editDamage: response.data.tripIncidents ? true : false
                                },
                            });
                        } else if (                        
                             currentActivity.activityCode == "130.000.00.001" ||  
                             this.pauseDActivityCodes.includes(currentActivity.activityCode)
                        ) {
                            return this.$router.push({
                                name: "add-pause",
                                query: {
                                    workday: this.workDay,
                                    workRegistrationId: this.selectedWorkRegistration.id,
                                    workDate: formatDateServer(this.workDate),
                                    isMidnight: this.passMidnight,
                                    workDayId: this.workDay.id,
                                    workDayEndTime: this.workDay.endTime,
                                    workRegistration: response.data,
                                    addTimeManually: this.selectedWorkRegistration.endTime
                                        ? true
                                        : false,
                                },
                            });
                        } else if (currentActivity.activityCode[0] != "1") {
                            return this.$router.push({
                                name: "add-other-activities",
                                query: {
                                    workday: this.workDay,
                                    workRegistrationId: this.selectedWorkRegistration.id,
                                    workDate: formatDateServer(this.workDate),
                                    isMidnight: this.passMidnight,
                                    workDayId: this.workDay.id,
                                    workDayEndTime: this.workDay.endTime,
                                    workRegistration: response.data,
                                    addTimeManually: this.selectedWorkRegistration.endTime
                                        ? true
                                        : false,
                                },
                            });
                        } else if (currentActivity.activityCode == "110.107.02.007") {
                            let rode = this.selectedWorkRegistration.description.substring(
                                23,
                                this.selectedWorkRegistration.description.length - 1
                            );
                            return this.$router.push({
                                name: "add-unforeseen",
                                query: {
                                    workday: this.workDay,
                                    workRegistrationId: this.selectedWorkRegistration.id,
                                    workDate: formatDateServer(this.workDate),
                                    isMidnight: this.passMidnight,
                                    workDayId: this.workDay.id,
                                    workDayEndTime: this.workDay.endTime,
                                    workRegistration: response.data,
                                    addTimeManually: this.selectedWorkRegistration.endTime
                                        ? true
                                        : false,
                                    rode: rode,
                                },
                            });
                        } else {
                            const currentWorkSlip = this.workSlips.find((item) => {
                                return (
                                    item.workSlipNumber == response.data.workSlipNumber &&
                                    item.activityId == response.data.activityId &&
                                    item.projectId == response.data.projectId
                                );
                            });
                            return this.$router.push({
                                name: "add-project-activity",
                                query: {
                                    workday: this.workDay,
                                    workRegistrationId: this.selectedWorkRegistration.id,
                                    workDate: formatDateServer(this.workDate),
                                    isMidnight: this.passMidnight,
                                    workDayId: this.workDay.id,
                                    workDayEndTime: this.workDay.endTime,
                                    workRegistration: response.data,
                                    addTimeManually: this.selectedWorkRegistration.endTime
                                        ? true
                                        : false,
                                    workslip: currentWorkSlip,
                                    otherActivities: currentWorkSlip ? false : true,
                                    editMode: true,
                                },
                            });
                        }
                    });
            },
            addTravelTime() {
                localStorage.setItem("selectedWorkDay", this.workDate)

                if (this.workRegistrations) {
                    var currentActivity = this.getActivityById(
                            this.workRegistrations[
                                this.workRegistrations.length - 1
                            ].activityTypeId.toString()
                        );
                    
                    if (currentActivity && (currentActivity.activityCode == "120.000.00.001" &&
                        !this.workRegistrations[this.workRegistrations.length - 1].endTime
                    )) {
                        this.endActivity();
                        this.showAddMenu = false;
                    } else {
                        return this.$router.push({
                            name: "add-travel-time",
                            query: {
                                workday: this.workDay,
                                workDate: formatDateServer(this.workDate),
                                isMidnight: this.passMidnight,
                                workDayId: this.workDay.id,
                                workDayEndTime: this.workDay.endTime,
                                drivers: this.workDay.drivers,
                            },
                        });
                    }
                } else {
                    return this.$router.push({
                        name: "add-travel-time",
                        query: {
                            workday: this.workDay,
                            workDate: formatDateServer(this.workDate),
                            isMidnight: this.passMidnight,
                            workDayId: this.workDay.id,
                            workDayEndTime: this.workDay.endTime,
                            drivers: this.workDay.drivers,
                        },
                    });
                }
            },
            addPause() {
                localStorage.setItem("selectedWorkDay", this.workDate)

                if (this.workRegistrations) {
                    var currentActivity = this.getActivityById(
                            this.workRegistrations[
                                this.workRegistrations.length - 1
                            ].activityTypeId.toString()
                        );
                    
                    if (currentActivity && (currentActivity.activityCode ==  "130.000.00.001" &&
                        !this.workRegistrations[this.workRegistrations.length - 1].endTime
                    )) {
                        this.endActivity();
                        this.showAddMenu = false;
                    } else {
                        return this.$router.push({
                            name: "add-pause",
                            query: {
                                workday: this.workDay,
                                workDate: formatDateServer(this.workDate),
                                isMidnight: this.passMidnight,
                                workDayId: this.workDay.id,
                                workDayEndTime: this.workDay.endTime,
                            },
                        });
                    }
                } else {
                    return this.$router.push({
                        name: "add-pause",
                        query: {
                            workday: this.workDay,
                            workDate: formatDateServer(this.workDate),
                            isMidnight: this.passMidnight,
                            workDayId: this.workDay.id,
                            workDayEndTime: this.workDay.endTime,
                        },
                    });
                }
            },
            otherSelection() {
                localStorage.setItem("selectedWorkDay", this.workDate)

                if (this.workRegistrations) {
                    var currentActivity = this.getActivityById(
                            this.workRegistrations[
                                this.workRegistrations.length - 1
                            ].activityTypeId.toString()
                        );

                    if (currentActivity && (currentActivity.activityCode[0] != "1" &&
                        !this.workRegistrations[this.workRegistrations.length - 1].endTime
                    )) {
                        this.endActivity();
                        this.showAddMenu = false;
                    } else if (
                        currentActivity && (currentActivity.activityCode == "110.107.02.007" &&
                        !this.workRegistrations[this.workRegistrations.length - 1].endTime
                    )) {
                        this.endActivity();
                        this.showAddMenu = false;
                    } else {
                        return this.$router.push({
                            name: "other-selection",
                            query: {
                                workday: this.workDay,
                                workDate: formatDateServer(this.workDate),
                                isMidnight: this.passMidnight,
                                workDayId: this.workDay.id,
                                workDayEndTime: this.workDay.endTime,
                            },
                        });
                    }
                } else {
                    return this.$router.push({
                        name: "other-selection",
                        query: {
                            workday: this.workDay,
                            workDate: formatDateServer(this.workDate),
                            isMidnight: this.passMidnight,
                            workDayId: this.workDay.id,
                            workDayEndTime: this.workDay.endTime,
                        },
                    });
                }
            },
            getWorkDayWithCurrentTime() {
                let workDate = new Date(this.workDate);
                workDate.setHours(new Date().getHours());
                workDate.setMinutes(new Date().getMinutes());
                return workDate;
            },
            onConfirmDamage(value) {
                this.showDamageModal = false;
                this.saveDay = true;
                if (value) {
                    this.showDamagePage = true;
                    let currentDate = this.getWorkDayWithCurrentTime();
                    let eTime = currentDate;
                    eTime = moment(eTime).toISOString();
                    eTime = formatDateTimeServer(eTime);

                    const dummyWorkReg =
                        this.workRegistrations[this.workRegistrations.length - 1];
                    dummyWorkReg.endTime = eTime;
                    dummyWorkReg.workDayId = this.workDay.id;

                    this.workRegistrationService
                        .getWorkRegistration(this.selectedWorkRegistration.id)
                        .then((response) => {
                            response.data.endTime = eTime;
                            return this.$router.push({
                                name: "add-travel-time",
                                query: {
                                    workday: this.workDay,
                                    workRegistrationId: this.selectedWorkRegistration.id,
                                    workDate: formatDateServer(this.workDate),
                                    isMidnight: this.passMidnight,
                                    workDayId: this.workDay.id,
                                    workDayEndTime: this.workDay.endTime,
                                    workRegistration: response.data,
                                    drivers: this.workDay.drivers,
                                    addTimeManually: this.selectedWorkRegistration.endTime
                                        ? true
                                        : false,
                                    showDamagePage: this.showDamagePage,
                                },
                            });
                        });
                } else {
                    this.showDamagePage = true;
                    let currentDate = this.getWorkDayWithCurrentTime();
                    let eTime = currentDate;
                    eTime = moment(eTime).toISOString();
                    eTime = formatDateTimeServer(eTime);

                    const dummyWorkReg =
                        this.workRegistrations[this.workRegistrations.length - 1];
                    dummyWorkReg.endTime = eTime;
                    dummyWorkReg.workDayId = this.workDay.id;
                    this.loader = this.$loading.show({});
                    this.workRegistrationService
                        .endWorkRegistration(dummyWorkReg.id, eTime)
                        .then((response) => {
                            this.workRegistrations[this.workRegistrations.length - 1].endTime =
                                response.data;
                            this.travelWithoutEndTime = false;
                            this.pauseWithoutEndTime = false;
                            this.projectWithoutEndTime = false;
                            this.otherWithoutEndTime = false;
                            this.travelTimeButtonLabel = this.$t("Workday.AddTravelTime");
                            this.pauseButtonLabel = this.$t("Workday.EnterPause");
                            this.projectButtonLabel = this.$t("Workday.ProjectActivity");
                            this.otherButtonLabel = this.$t("Workday.Other");
                            this.loader.hide();
                        })
                        .catch(() => {
                            this.loader.hide();
                        });
                }
            },
            // checkDamage(){
            //   if (this.isDriver && !this.editDamage && this.selectedStartTime && this.selectedEndTime) {
            //       this.showDamageModal = true;
            //     } else {
            //       this.saveDay = true;
            //       this.checkIfWorkDayExists();
            //     }
            // },
            endActivity() {
                let currentDate = this.getWorkDayWithCurrentTime();
                if (
                    new Date(currentDate).getTime() <=
                    new Date(
                        this.workRegistrations[this.workRegistrations.length - 1].startTime
                    ).getTime()
                ) {
                    this.$toast.add({
                        severity: "warn",
                        detail: "End time must be greater than start time",
                        life: 3000,
                        closable: false,
                    });
                } else {
                    let eTime = currentDate;
                    eTime = moment(eTime).toISOString();
                    eTime = formatDateTimeServer(eTime);

                    const dummyWorkReg =
                        this.workRegistrations[this.workRegistrations.length - 1];

                    if (dummyWorkReg.activityTypeId == 182) {
                        let remarks = dummyWorkReg.description.split("||");
                        remarks.forEach((value) => {
                            if (value.includes("Driver: ")) {
                                this.isDriver = true;
                            }
                            if (value.includes("Damage: ")) {
                                this.damageDescription = value.substring(
                                    value.indexOf("Damage: ") + 8,
                                    value.length - 1
                                );
                                this.editDamage = true;
                            }
                            if (value.includes("Car: ")) {
                                this.selectedCarType = value.substring(value.indexOf("Car: ") + 5, value.length - 1);
                            }
                            if (value.includes("Distance: ")) {
                                this.distance = value.substring(
                                    value.indexOf("Distance: ") + 10,
                                    value.length - 1
                                );
                            }
                            if (value.includes("LicensePlate: ")) {
                                this.licensePlate = value.substring(
                                    value.indexOf("LicensePlate: ") + 14,
                                    value.length - 1
                                );
                            }
                        });
                        if (
                            (this.selectedCarType == 0 || this.selectedCarType == -1) &&
                            (!this.distance || !this.licensePlate) &&
                            this.isDriver
                        ) {
                            this.$toast.add({
                                severity: "warn",
                                detail: "Please edit the work registration to fill in the number of kilometers and license plate",
                                life: 3000,
                                closable: false,
                            });
                            return false;
                        }
                        if (this.isDriver && !this.editDamage && dummyWorkReg.startTime) {
                            this.showDamageModal = true;
                        } else {
                            this.loader = this.$loading.show({});
                            this.workRegistrationService
                                .endWorkRegistration(dummyWorkReg.id, eTime)
                                .then((response) => {
                                    this.workRegistrations[
                                        this.workRegistrations.length - 1
                                    ].endTime = response.data;
                                    this.travelWithoutEndTime = false;
                                    this.pauseWithoutEndTime = false;
                                    this.projectWithoutEndTime = false;
                                    this.otherWithoutEndTime = false;
                                    this.travelTimeButtonLabel = this.$t("Workday.AddTravelTime");
                                    this.pauseButtonLabel = this.$t("Workday.EnterPause");
                                    this.projectButtonLabel = this.$t("Workday.ProjectActivity");
                                    this.otherButtonLabel = this.$t("Workday.Other");
                                    this.loader.hide();
                                })
                                .catch(() => {
                                    this.loader.hide();
                                });
                        }
                    } else {
                        this.loader = this.$loading.show({});
                        this.workRegistrationService
                            .endWorkRegistration(dummyWorkReg.id, eTime)
                            .then((response) => {
                                this.workRegistrations[
                                    this.workRegistrations.length - 1
                                ].endTime = response.data;
                                this.travelWithoutEndTime = false;
                                this.pauseWithoutEndTime = false;
                                this.projectWithoutEndTime = false;
                                this.otherWithoutEndTime = false;
                                this.travelTimeButtonLabel = this.$t("Workday.AddTravelTime");
                                this.pauseButtonLabel = this.$t("Workday.EnterPause");
                                this.projectButtonLabel = this.$t("Workday.ProjectActivity");
                                this.otherButtonLabel = this.$t("Workday.Other");
                                this.loader.hide();
                            })
                            .catch(() => {
                                this.loader.hide();
                            });
                    }
                }
            },
            addProjectActivity() {
                localStorage.setItem("selectedWorkDay", this.workDay.workDate)

                if (this.workRegistrations) {
                    var lastWrActivity = this.getActivityById(
                        this.workRegistrations[
                            this.workRegistrations.length - 1
                        ].activityTypeId.toString()
                    );
                    if (lastWrActivity && (
                        lastWrActivity.activityCode[0] == "1" &&
                        lastWrActivity.activityCode != "130.000.00.001" &&
                        lastWrActivity.activityCode != "120.000.00.001" &&
                        lastWrActivity.activityCode != "110.107.02.007" &&
                        !this.workRegistrations[this.workRegistrations.length - 1].endTime
                    )) {
                        this.endActivity();
                        this.showAddMenu = false;
                    } else {
                        return this.$router.push({
                            name: "project-overview",
                            query: {
                                workday: this.workDay,
                                workDate: formatDateServer(this.workDate),
                                isMidnight: this.passMidnight,
                                workDayId: this.workDay.id,
                                workDayEndTime: this.workDay.endTime,
                                isWorkSlipEmployee: this.isWorkSlipEmployee,
                            },
                        });
                    }
                } else {
                    return this.$router.push({
                        name: "project-overview",
                        query: {
                            workday: this.workDay,
                            workDate: formatDateServer(this.workDate),
                            isMidnight: this.passMidnight,
                            workDayId: this.workDay.id,
                            workDayEndTime: this.workDay.endTime,
                            isWorkSlipEmployee: this.isWorkSlipEmployee,
                        },
                    });
                }
            },
            createWorkRegistration() {
                /* return this.$router.push({
                  name: "create-work-registration",
                  query: {
                    workDay: this.workDay,
                    workDate: formatDateServer(this.workDate),
                    isMidnight: this.passMidnight,
                    workDayId: this.workDay.id,
                  },
                }); */
                this.showAddMenu = true;
            },
            next: function () {
                this.workDate = moment(this.workDate).add("days", 1).toDate();
                this.workDate = formatDateServer(this.workDate);
                localStorage.removeItem("selectedWorkDay");
                this.$router.push({
                    name: "work-day",
                    query: { workDate: formatDateServer(this.workDate) },
                });
                this.showAddMenu = false;
                this.getWorkDay();
            },
            back: function () {
                this.workDate = moment(this.workDate).add("days", -1).toDate();
                this.workDate = formatDateServer(this.workDate);
                localStorage.removeItem("selectedWorkDay");
                this.$router.push({
                    name: "work-day",
                    query: { workDate: formatDateServer(this.workDate) },
                });
                this.showAddMenu = false;
                this.getWorkDay();
            },
            swipeHandler(direction) {
                if (process.env.VUE_APP_USE_SWIPE === "false") return;
                if (direction === "left") this.next();
                if (direction === "right") this.back();
            },
            checkPausetime() {
                let sum = 0;
                this.workRegistrations.forEach((wr) => {
                    var currentActivity = this.activities.find(
                        (activity) => activity.id == wr.activityTypeId
                    );
                    
                    if (currentActivity && (currentActivity.activityCode == "130.000.00.001" || (currentActivity.name.toLowerCase().includes("pauze d")))) {
                        sum += this.getDifferenceBetween2Dates(wr.startTime, wr.endTime);
                        console.log("The pause sum is:", sum);
                    }
                });
                if (sum < 60 * 60 * 1000) {
                    this.showBreakModal = true;
                } else {
                    this.openCloseDayDialog();
                }
            },
            openCloseDayDialog() {
                if (this.workRegistrations[this.workRegistrations.length - 1].endTime) {
                    this.onCloseDay();
                } else {
                    this.showEndTimeDialog = true;
                }
            },
            onCloseDay() {
                let valid = this.validate();
                if (valid) {
                    if (this.isWorkSlipEmployee || !this.addedEndTime) {
                        this.showConfirmationModalForCloseWorkDay = true;
                    } else {
                        this.onConfirmCloseDay(true);
                    }
                }
            },
            select(item) {
                this.workRegistrations.forEach((s) => (s.selected = false));
                if (
                    this.selectedWorkRegistration &&
                    this.selectedWorkRegistration.id == item.id
                ) {
                    item.selected = false;
                    this.selectedWorkRegistration = null;
                } else {
                    item.selected = true;
                    this.selectedWorkRegistration = item;
                }
            },
            onPassMidnightChange() {
                if (!this.passMidnight) {
                    let workDate = moment(this.workDay.workDate);
                    let d = workDate.date();
                    this.workRegistrations.forEach((w) => {
                        if (moment(w.startTime).diff(workDate, "days") !== 0) {
                            w.startTime = moment(w.startTime)
                                .set("date", d)
                                .format("YYYY-MM-DD[T]HH:mm:00");
                        }
                        if (moment(w.endTime).diff(workDate, "days") !== 0) {
                            w.endTime = moment(w.endTime)
                                .set("date", d)
                                .format("YYYY-MM-DD[T]HH:mm:00");
                        }
                    });
                }
            },
            validate() {
                let validationErrorList = [];
                let validationWarningList = [];
                this.val;
                for (let i = 0; i < this.workRegistrations.length; i++) {
                    this.workRegistrations[i].invalidStartTime = false;
                    this.workRegistrations[i].invalidEndTime = false;
                    let prev = i - 1;
                    let next = i + 1;
                    const currentStartTime = new Date(
                        this.workRegistrations[i].startTime
                    ).getTime();
                    const currentEndTime = new Date(
                        this.workRegistrations[i].endTime
                    ).getTime();
                    if (isNaN(currentStartTime)) {
                        {
                            validationErrorList.push({
                                line: i + 1,
                                error: `${i + 1} ${this.$t("CloseWorkDay.MissingStartTime")}`,
                            });
                            this.workRegistrations[i].invalidStartTime = true;
                        }
                    }
                    if (isNaN(currentEndTime)) {
                        {
                            validationErrorList.push({
                                line: i + 1,
                                error: `${i + 1} ${this.$t("CloseWorkDay.MissingEndtime")}`,
                            });
                            this.workRegistrations[i].invalidEndTime = true;
                        }
                    }
                    if (currentStartTime >= currentEndTime) {
                        this.workRegistrations[i].endTime = null;
                        validationErrorList.push({
                            line: i + 1,
                            error: `${i + 1} ${this.$t(
                                "CloseWorkDay.StartTimeBiggerThanEndTime"
                            )}`,
                        });
                        this.workRegistrations[i].invalidStartTime = true;
                    }

                    if (
                        moment
                            .duration(moment(currentEndTime).diff(moment(currentStartTime)))
                            .asMinutes() === 1
                    ) {
                        validationWarningList.push({
                            line: i + 1,
                            error: `${i + 1} ${this.$t("CloseWorkDay.Duration")}`,
                        });
                        this.workRegistrations[i].invalidStartTime = true;
                        this.workRegistrations[i].invalidEndTime = true;
                    }

                    if (this.workRegistrations[next]) {
                        if (
                            currentEndTime !==
                            new Date(this.workRegistrations[next].startTime).getTime()
                        ) {
                            validationErrorList.push({
                                line: next + 1,
                                error: `${i + 1} ${this.$t(
                                    "CloseWorkDay.EndTimeNotMatchWithStartTime",
                                    {
                                        nextline: next + 1,
                                    }
                                )}`,
                            });
                            this.workRegistrations[i].invalidEndTime = true;
                        }
                    }

                    if (this.workRegistrations[prev]) {
                        if (
                            currentStartTime !==
                            new Date(this.workRegistrations[prev].endTime).getTime()
                        ) {
                            validationErrorList.push({
                                line: prev + 1,
                                error: `${i + 1} ${this.$t(
                                    "CloseWorkDay.StartTimeNotMatchWithEndTime",
                                    {
                                        previousLine: prev + 1,
                                    }
                                )}`,
                            });
                            this.workRegistrations[i].invalidStartTime = true;
                        }
                    }
                }
                if (validationWarningList.length > 0) {
                    let message = "";
                    validationWarningList
                        .sort((s) => s.line)
                        .forEach((item) => {
                            message += item.error + "\n";
                        });
                    this.$toast.add({
                        severity: "warn",
                        detail: message,
                        life: 3000,
                        closable: false,
                    });
                }
                if (validationErrorList.length > 0) {
                    let message = "";
                    validationErrorList
                        .sort((s) => s.line)
                        .forEach((item) => {
                            message += item.error + "\n";
                        });
                    let clone = [...this.workRegistrations];
                    this.workRegistrations = [];
                    setTimeout(() => {
                        this.workRegistrations = clone;
                    }, 0);
                    this.$toast.add({
                        severity: "error",
                        detail: message,
                        life: 3000,
                        closable: false,
                    });
                    return false;
                }
                return true;
            },
            isEnabledMidnightOption() {
                let isMidnight =
                    this.localStorageService.getCurrentEmployee().isEnabledMidnightOption ||
                    false;
                if (!isMidnight)
                    return this.workRegistrations.some(
                        (w) =>
                            w.endTime && moment(w.startTime).day() !== moment(w.endTime).day()
                    );
                return isMidnight;
            },
            updateWorkRegistrationDates() {
                let model = this.workRegistrations.map((w) => {
                    return {
                        id: w.id,
                        startTime: formatDateTimeServer(w.startTime),
                        endTime: w.endTime !== "" ? formatDateTimeServer(w.endTime) : null,
                    };
                });
                this.loader = this.$loading.show({});
                this.workRegistrationService
                    .updateWorkRegistrationDates(model)
                    .then(() => {
                        this.loader.hide();
                    })
                    .catch(() => {
                        this.loader.hide();
                    });
            },
            updateWorkRegistrationEndTime() {
                let model = this.workRegistrations.map((w) => {
                    return {
                        id: w.id,
                        startTime: formatDateTimeServer(w.startTime),
                        endTime: w.endTime !== "" ? formatDateTimeServer(w.endTime) : null,
                    };
                });
                this.loader = this.$loading.show({});
                this.workRegistrationService
                    .updateWorkRegistrationDates(model)
                    .then(() => {
                        this.loader.hide();
                        this.onCloseDay();
                    })
                    .catch(() => {
                        this.loader.hide();
                    });
            },
            getCardAccess(workday) {
                const employeeId = workday.employeeId;
                const workDate = workday.workDate;
                this.cardAcess = [];
                this.workDayService.getCardAccess(employeeId, workDate).then((res) => {
                    res.data.forEach((element) => {
                        this.cardAcess.push(
                            new Date(element.registrationDateTime).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                            })
                        );
                    });
                });
            },
            getActivities() {
                this.activityService.getActivityInfos().then((response) => {
                    this.activities = response.data;
                    this.changeLastWrButtonLabel();
                });
            },
            getActivityById(id) {
                return this.activities.find((item) => {
                    return item.id == id;
                });
            },
            changeLastWrButtonLabel() {
                if (this.workRegistrations != null && !this.workRegistrations[this.workRegistrations.length - 1].endTime) {
                    var currentActivity = this.getActivityById(
                            this.workRegistrations[
                                this.workRegistrations.length - 1
                            ].activityTypeId.toString()
                        );
                    
                    if (currentActivity && (currentActivity.activityCode == "120.000.00.001"
                    )) {
                        this.travelTimeButtonLabel = this.$t(
                            "WorkRegistrationForm.TravelButtonEnd"
                        );
                        this.travelWithoutEndTime = true;
                    } else if (currentActivity && (currentActivity.activityCode == "130.000.00.001"
                    )) {
                        this.pauseButtonLabel = this.$t(
                            "WorkRegistrationForm.PauseButtonEnd"
                        );
                        this.pauseWithoutEndTime = true;
                    } else if (currentActivity && (currentActivity.activityCode[0] != "1" ||
                                                    currentActivity.activityCode == "110.107.02.007"
                    )) {
                        this.otherButtonLabel = this.$t(
                            "WorkRegistrationForm.OtherButtonEnd"
                        );
                        this.otherWithoutEndTime = true;
                    } else {
                        this.projectButtonLabel = this.$t(
                            "WorkRegistrationForm.ProjectButtonEnd"
                        );
                        this.projectWithoutEndTime = true;
                    }
                }
            },
            getDifferenceBetween2Dates(date1, date2) {
                if (!date1 || !date2) {
                    return 0;
                }
                const diffTime = Math.abs(new Date(date2) - new Date(date1));
                return diffTime;
            },
            testWR() {
                let act = this.activities.find((item) => {
                    return item.activityCode == "110.121.02.001";
                });
                console.log(act);
                let prj = {
                    id: 9155,
                    isRecent: true,
                    name: "S0050 Algemeen",
                };
                console.log(prj);
                return this.$router.push({
                    name: "add-project-activity",
                    query: {
                        workday: this.workDay,
                        workDate: formatDateServer(this.workDate),
                        isMidnight: this.passMidnight,
                        workDayId: this.workDay.id,
                        workDayEndTime: this.workDay.endTime,
                        addTimeManually: true,
                        otherActivities: true,
                        isStandardDay: true,
                        selectedActivity: act,
                        selectedProject: prj,
                    },
                });
            },
            onConfirmBreak(value, checkvalue) {
                this.showBreakModal = false;

                console.log('yes clicked: ', value); 
                console.log('workslipemployee: ', this.isWorkSlipEmployee);
                console.log('checkbox checked: ', checkvalue);
                
                if (!value) //No pressed
                  return;
                
                if(!this.isWorkSlipEmployee){
                   this.openCloseDayDialog();
                }
                else if (this.isWorkSlipEmployee && checkvalue) {
                    console.log('breaks are agreed')
                    this.openCloseDayDialog();
                } else if(this.isWorkSlipEmployee && !checkvalue) {
                    console.log('insert default breaks')
                    this.workRegistrationService
                        .insertDefaultBreak(this.workDay.id)
                        .then((response) => {
                            this.openCloseDayDialog();
                        });
                }
            },
            overnightCheck() {
                this.workSlipService
                    .isEmployeeStayingOvernight(formatDateTimeServer(this.workDate))
                    .then((response) => {
                        this.isEmployeeStayingOvernight = response.data;
                    });
            },
            onConfirmOvernight(value) {
                this.showOvernightModal = false;
                this.workSlipService
                    .changeEmployeeOvernightStatus(
                        formatDateTimeServer(this.workDate),
                        value
                    )
                    .then((response) => {
                        this.checkPausetime();
                    });
            },
            getContractFormat() {
                this.workDayService.getEmployeeContractFormat().then((response) => {
                    this.contractFormat = response.data;
                });
            },
            checkForOvertime() {
                if (this.contractFormat.overTimeStartHours && this.contractFormat.overTimeStartHours != 999) {
                    let sum = 0;
                    this.workRegistrations.forEach((wr) => {
                        if (wr.activityTypeId != 9) {
                            let diffDate = new Date(wr.endTime) - new Date(wr.startTime);
                            console.log(diffDate);
                            sum += diffDate / (60 * 60 * 1000);
                            console.log(diffDate / (60 * 60 * 1000));
                            console.log(sum);
                            // sum +=
                            //   new Date(wr.endTime).getHours() -
                            //   new Date(wr.startTime).getHours();
                            // sum +=
                            //   new Date(wr.endTime).getMinutes() / 60 -
                            //   new Date(wr.startTime).getMinutes() / 60;
                        }
                    });
                    if (
                        this.contractFormat.dailyContractHours < sum &&
                        sum - this.contractFormat.dailyContractHours >=
                        this.contractFormat.minimumOvertimeStart
                    ) {
                        this.showOvertimeModal = true;
                        this.overtimeInHours = sum - this.contractFormat.dailyContractHours;
                    } else {
                        this.isEmployeeStayingOvernight
                            ? (this.showOvernightModal = true)
                            : this.checkPausetime();
                    }
                } else {
                    this.isEmployeeStayingOvernight
                        ? (this.showOvernightModal = true)
                        : this.checkPausetime();
                }
            },
            onConfirmOvertime(value) {
                this.declare = true;
                this.showOvertimeModal = false;
                if (!value) {
                    this.overtimeInHours = null;
                    this.declare = false;
                }
                this.isEmployeeStayingOvernight
                    ? (this.showOvernightModal = true)
                    : this.checkPausetime();
            },
        },
    };
</script>

<style>
    #workslip {
        margin-top: 10px;
    }

        #workslip .selected {
            background-color: #019ee9 !important;
        }

        #workslip .vdatetime-input {
            width: 70px;
        }

        #workslip .table th,
        .table td {
            padding: 0.5rem !important;
        }

    .error {
        border: 1px solid red;
    }

    .p-toast {
        width: 100%;
    }

    .p-toast-message {
        white-space: pre;
        text-align: center;
    }

    .tooltip-wrapper {
        position: relative;
    }

    .tooltip-button {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
    }

    .tooltip-text {
        position: absolute;
        top: 50%;
        right: 100%;
        transform: translate(-1%, -50%);
        padding: 5px;
        background-color: #f2f2f2;
        border: 1px solid #ccc;
        border-radius: 3px;
        white-space: normal;
        word-wrap: break-word;
        width: 300px;
        z-index: 9999;
    }


    .tooltip-button:hover .tooltip-text {
        display: block;
    }

    @media (max-width: 768px) {
        .tooltip-text {
            display: none;
        }
    }
</style>
